import React from "react";
import { Box, Card, Typography, Button, Chip, Stack } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function CompletedJobCard() {
  const { completedJobs } = useSelector((state) => state.vendorJob);
  const navigate = useNavigate();
  const formatPrice = (price) => `₹${price.toLocaleString("en-IN")}`;

  return (
    <Box
      sx={{
        borderRadius: 5,
        backgroundColor: "white",
      }}
    >
      {/* Header */}
      <Box
        px={4}
        py={2}
        sx={{
          top: 0,
          backgroundColor: "#F8FAFC",
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          borderBottom: "2px solid #E0E0E0",
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 600 }}>
          Completed
        </Typography>
        <Typography>{`${completedJobs?.length} Cluster`}</Typography>
      </Box>

      {/* Card Grid */}
      <div className=" flex gap-4 my-2 ">
        <div className="w-full p-4 overflow-y-auto h-[70vh] rounded-2xl bg-[#F5F5F5] ">
          <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {completedJobs.map((cluster, index) => (
              <Card
                key={cluster._id}
                sx={{
                  width: "100%",
                  borderRadius: 5,
                  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
                  padding: 2,
                  backgroundColor: "white",
                  marginBottom: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="h6"
                    component="h2"
                    sx={{ fontWeight: 600, mb: 1 }}
                  >
                    {cluster?.productType}
                  </Typography>

                  <Chip
                    label={
                      cluster?.totalAmountPaid == cluster?.paymentAmount
                        ? "Amount Done"
                        : "Payment Due"
                    }
                    sx={{
                      backgroundColor:
                        cluster?.totalAmountPaid === cluster?.paymentAmount
                          ? "rgba(76, 175, 80, 0.1)"
                          : "#FFFBE5",
                      color:
                        cluster?.totalAmountPaid === cluster?.paymentAmount
                          ? "#4caf50"
                          : "#FFD600",
                      fontWeight: 600,
                      borderRadius: 5,
                      height: 28,
                    }}
                  />
                </Box>

                <Typography variant="body2" color="text.secondary" pb={1}>
                  {new Date(cluster?.jobStartingDate).toLocaleDateString(
                    "en-GB",
                    {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    }
                  )}{" "}
                  -{" "}
                  {new Date(cluster?.jobCompletionDate).toLocaleDateString(
                    "en-GB",
                    {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    }
                  )}
                  <Box component="span" sx={{ mx: 1 }}>
                    •
                  </Box>
                  {cluster?.totalNumberOfBatches} Nos
                </Typography>
                <Box pb={1} sx={{ mb: 1, borderBottom: "2px dashed #E0E0E0" }}>
                  <Stack direction="row" alignItems="center" gap={2}>
                    <Chip
                      label={
                        cluster?.serviceType === "0"
                          ? "Fabrication & Printing"
                          : cluster?.serviceType === "1"
                          ? "Fabrication"
                          : cluster?.serviceType === "2"
                          ? "Printing"
                          : "Unknown"
                      }
                      sx={{
                        bgcolor: "#A3AED033",
                        color: "#2B3674",
                        fontWeight: 600,
                        borderRadius: 5,
                        height: 28,
                      }}
                    />
                    <Chip
                      label={formatPrice(cluster?.paymentAmount)}
                      sx={{
                        bgcolor: "#A3AED033",
                        color: "#2B3674",
                        fontWeight: 600,
                        borderRadius: 5,
                        height: 28,
                      }}
                    />
                  </Stack>
                </Box>

                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Button
                    variant="text"
                    sx={{
                      color: "text.primary",
                      textDecoration: "underline",
                      p: 0,
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                      fontWeight: 500,
                      borderRadius: 1,
                    }}
                    onClick={() => navigate("/vendorportal/jobs/cluster")}
                  >
                    View Details
                  </Button>
                </Stack>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </Box>
  );
}
